import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, X } from "lucide-react";
import { api } from "@/lib/api";
import { useStoreStatus, opensLabel } from "@/context/StoreContext";

// Storefront strip: shows the owner's announcement banner and/or a "closed" notice.
export default function AnnouncementBanner() {
  const [config, setConfig] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const { status } = useStoreStatus();

  useEffect(() => {
    api.get("/site/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  if (!config) return null;
  const closed = status && !status.is_open;
  const banner = config.banner;
  const showBanner = banner?.enabled && banner?.text && !dismissed;
  if (!closed && !showBanner) return null;

  return (
    <div className="fixed top-16 left-0 right-0 z-40" data-testid="announcement-banner">
      {closed && (
        <div className="bg-red-600 text-white text-center text-sm font-bold py-2 px-4" data-testid="closed-notice">
          {status.reason === "manual" ? (status.message || "We're closed for a short while") : status.message ? `Closed today — ${status.message}` : "We're closed right now"} · {opensLabel(status)} · You can still browse the menu.
        </div>
      )}
      {showBanner && (
        <div className="bg-biga-ink text-biga-cream text-sm font-bold py-2 px-4 flex items-center justify-center gap-2">
          <Megaphone size={15} className="text-biga-orange shrink-0" />
          {banner.link ? (
            /^https?:\/\//.test(banner.link)
              ? <a href={banner.link} target="_blank" rel="noopener noreferrer" data-testid="announcement-banner-link" className="hover:text-biga-orange underline-offset-2 hover:underline">{banner.text}</a>
              : <Link to={banner.link} data-testid="announcement-banner-link" className="hover:text-biga-orange underline-offset-2 hover:underline">{banner.text}</Link>
          ) : (
            <span>{banner.text}</span>
          )}
          <button onClick={() => setDismissed(true)} data-testid="dismiss-banner" className="ml-2 opacity-60 hover:opacity-100"><X size={14} /></button>
        </div>
      )}
    </div>
  );
}
